// extracted by mini-css-extract-plugin
export default {"check":"transactionTableList_check__9orT4"};